import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperMyLeadUnitDetailsFields: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerItem: {
      display: "flex",
      flexDirection: "row",
      gap: "32px",
      minHeight: "61px",
      alignItems: "center",
    },
    containerTitle: {
      maxWidth: "280px",
      minWidth: "160px",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
  };
});
